<div class="whitelist">
  @for (group of selectableGroups; track group) {
    <div class="whitelist-item"
      [ngClass]="{selected: group.is_selected, disabled: group.is_disabled}"
      (click)="toggleSelect(group)"
      >
      <i class="fa" [ngClass]="group.is_selected?'fa-check':'fa-times'"></i> {{group.group_id}} {{group.name}}
    </div>
  }
</div>
